<template>
  <div class="form__field-box" :data-vv-as="label" data-vv-value-path="model">
    <label class="form__label" v-if="label">{{label}}</label>
    <div
      class="v-input v-input__datetimepicker"
      :class="{ 'v-input--is-dirty': isDirty, 'v-input--is-disabled': disabled,
      'v-input__error--border': !!errors.has(newName) }">
      <input
        class="v-input__field v-input__field--datepicker"
        v-model="model"
        type="text"
        @change="$emit('input', model)"
        ref="picker"
        @focus="show"
        @blur="hide"
        :name="name"
        @input="$emit('input', model)"
        v-validate="`date_format:DD-MM-YYYY`"
        :disabled="disabled">

      <input type="hidden" v-model="hidden" :name="name">

      <div class="v-input__error" v-if="errors.has(newName)">
        {{ errors.first(newName) }}
      </div>
    </div>
  </div>
</template>

<script>
import field from "../mixins/field";
import $ from "jquery";
import "tempusdominus-bootstrap-4";

export default {
  computed: {
    hidden() {
      if (this.model) {
        let datetime = this.model.split(" ");
        let date = datetime[0].split("-");
        let time = "";

        if (datetime[1]) {
          time = " " + datetime[1];
        }
        return date[0] && date[1] && date[2]
          ? `${date[2]}-${date[1]}-${date[0]}${time}`
          : "";
      }

      return "";
    }
  },
  mounted() {
    moment.updateLocale("en", {
      week: { dow: 1 } // Monday is the first day of the week
    });
    var todayDate = moment().startOf('day');
    if (!this.pastDates) {
      $(this.$refs.picker).datetimepicker({
        format: this.format,
        minDate: todayDate
      });
    } else {
      if (this.decades) {
        $(this.$refs.picker).datetimepicker({
          format: this.format,
          viewMode: "decades"
        });
      } else {
        $(this.$refs.picker).datetimepicker({
          format: this.format
        });
      }
    }

    $(this.$refs.picker).on("input.datetimepicker", e => {
      this.model = e.target.value;
    });
  },
  methods: {
    show() {
      $(this.$refs.picker).datetimepicker("show");
    },
    hide() {
      $(this.$refs.picker).datetimepicker("hide");
    }
  },
  mixins: [field],
  props: {
    decades: false,
    pastDates: {
      default: true,
      type: Boolean
    },
    format: {
      default: "DD-MM-YYYY",
      type: String
    }
  }
};
</script>

<style>
.bootstrap-datetimepicker-widget .list-unstyled {
  list-style: none;
  padding: 0;
  margin: 0;
}
.bootstrap-datetimepicker-widget.dropdown-menu {
  position: absolute;
  background: #fff;
  border: 1px solid #dcdbdb;
}
.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td span.active {
  background-color: #26a69a;
}
.bootstrap-datetimepicker-widget table td.active:hover {
  background-color: #006c5f;
}
.v-input__datetimepicker.v-input__error--border .v-input__field {
  border-color: red;
}
.v-input__datetimepicker.v-input__error--border {
  box-shadow: none;
}
</style>


// WEBPACK FOOTER //
// resources/js/admin/components/VDatepickerPublic.vue